import { put, call, select } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';
import { getUser } from 'reducers';
import { getHistory } from 'billing/purchases/actions';

export function* purchaseHistoryNavigate(_, query) {
  const page = query && query.page ? query.page : 1;
  yield call(authenticateUser);
  const { id } = yield select(getUser);
  yield put(getHistory(id, page));
}
